import { h } from 'preact'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import Img from '../components/Img'
import { getImageStatus, getImageVersion } from '../helpers/mediaItems'
import { ImageVersionType } from '../reducers'
import fallbackImg from '../images/JOIN-Company-Logo-Placeholder.jpg'

const StyledImage = Img.extend`
  img {
    border-radius: 3px;
    box-shadow: 0 0 5px rgba(58, 58, 58, .1)
  }
`

const CompanyLogo = ({ className, imageItem, versionType }) => (
  <StyledImage
    className={className}
    itemVersion={getImageVersion(imageItem, versionType)}
    itemStatus={getImageStatus(imageItem)}
    fallbackSrc={fallbackImg}
  />
)

CompanyLogo.propTypes = {
  imageItem: ImageVersionType,
  versionType: PropTypes.string.isRequired,
  className: PropTypes.string
}

CompanyLogo.defaultProps = {
  imageItem: null,
  className: ''
}

export default styled(CompanyLogo)``



// WEBPACK FOOTER //
// ./src/components/CompanyLogo.js